"use client";

import React from "react";
import HighCommissions from "./HighCommissions";
import KOLVideo from "./KOLVideo";

import "./index.scss";

const SellingProduct: React.FC = () => {
  return (
    <div className="w-full YF-intro flex flex-col items-center">
      <div className="selling-bg">
        <h2 className="text-[42px] font-semibold">
          Make Your Sales Make Sense!
        </h2>
        <p className="text-2xl font-medium">High Commission Series</p>
        <HighCommissions />
      </div>
      <KOLVideo />
    </div>
  );
};

export default SellingProduct;
